import { useSelector } from "react-redux";
import { pathOr } from "ramda";

import { useLastEcardActions } from "store/LastEcardSlice";
import useRouter from "hooks/useRouter";
import { ECARD_TYPES } from "enums";
import localStorage, { ECARD, TEMPLATE_GROUP, TEMPLATE_GROUP_ID, INVITE_ID, IN_FLOW } from "utils/localStorage";

const useLastEcard = () => {
  const { setLastEcard, setInFlow, clearLastEcard } = useLastEcardActions();
  const { location } = useRouter();

  const { ecard: currentEcard, templateGroup: currentTemplateGroup, inFlow: currentFlow } = useSelector(
    (state) => state.LastEcardSlice,
  );

  const ecard = (() => currentEcard || localStorage.getItem(ECARD))();
  const templateGroup = (() => currentTemplateGroup || localStorage.getItem(TEMPLATE_GROUP))();
  const inFlow = (() => currentFlow || localStorage.getItem(IN_FLOW))();

  const isInvite = ecard && ecard.type === ECARD_TYPES.INVITE;
  const isMake = ecard && ecard.type === ECARD_TYPES.MAKE;

  const templateGroupId = (() => {
    let id = localStorage.getItem(TEMPLATE_GROUP_ID);
    const tgIdFromUrl = pathOr(null, ["state", "templateGroup"], location);

    if (isInvite && ecard?.templateGroupId) id = ecard.templateGroupId;
    else if (tgIdFromUrl) id = tgIdFromUrl;

    return id;
  })();

  const ecardType = (() => {
    let type;
    const inviteId = localStorage.getItem(INVITE_ID);

    if (ecard && ecard.type) type = ecard.type;
    else if (inviteId) type = ECARD_TYPES.INVITE;

    return type;
  })();

  return {
    setLastEcard,
    setInFlow,
    inFlow,
    clearLastEcard,
    ecard,
    isInvite,
    isMake,
    templateGroupId,
    ecardType,
    templateGroup,
  };
};

export default useLastEcard;
